import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  Signal,
  signal,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '@brightside/core/auth';
import {
  trigger,
  transition,
  style,
  animate,
} from '@angular/animations';
import { MenuComponent } from '../menu/menu.component';
import { RippleModule } from 'primeng/ripple';
import { Avatar } from 'primeng/avatar';
import { OmniSearchComponent } from '@brighthub/search';
import { NgClass } from '@angular/common';
import {
  MenuItem,
  MenuKey,
  MenuStore,
} from '@brighthub/shell/data-access-menu';
import { DemoStepControlsComponent } from '../demo-step-controls/demo-step-controls.component';
import { NotificationsComponent } from '../notifications/notifications.component';

@Component({
  selector: 'bhub-shell',
  standalone: true,
  imports: [
    RippleModule,
    RouterModule,
    MenuComponent,
    Avatar,
    OmniSearchComponent,
    NgClass,
    DemoStepControlsComponent,
    NotificationsComponent,
  ],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms ease-in', style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class ShellComponent {
  private _auth = inject(AuthService);
  private _menuStore = inject(MenuStore);

  readonly userDisplayName = this._auth.userDisplayName;
  isSidebarCollapsed = signal(true);
  menuItems: Signal<MenuItem[]> = this._menuStore.menu(MenuKey.MAIN);
  displayMenu = signal<boolean>(false);

  constructor() {
    effect(() => {
      const menuItems = this.menuItems();
      if (menuItems && menuItems.length >= 2) {
        this.displayMenu.set(true);
      }
    });
  }

  toggleSidebarCollapse(): void {
    this.isSidebarCollapsed.update((collapsed) => !collapsed);
  }

  signOut(): void {
    this._auth.signOut();
  }
}
